import { Component } from '@angular/core';
import { NavController, NavParams, Events, IonicPage } from 'ionic-angular';
import { DeveloperProvider } from '../../../../providers/developers';
import { CustomErrorHandler } from '@questrade/flx-commons';

@IonicPage({
  name: 'ext-magento-2',
  defaultHistory: ['home']
})
@Component({
  selector: 'page-ext-magento-2',
  templateUrl: 'ext-magento-2.html',
})
export class ExtMagento_2Page {
  docuData;
  constructor(
    public events: Events,
    public navCtrl: NavController,
    public navParams: NavParams,
    private devProvider: DeveloperProvider,
    private customErrorHandler: CustomErrorHandler) {
    this.docuData = [];
  }
}



// WEBPACK FOOTER //
// ./src/pages/extensions/ext-platforms/ext-magento-2/ext-magento-2.ts